/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React, { Requireable } from "react";
import i18n from "i18n";
import "./style.css";

interface Props {
  className: any;
  text: string;
  hasDiv: boolean;
  dataInput: string;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export class ShortAnswer extends React.Component<Props> {
  static defaultProps = { dataInput: "", text: "Type a question", hasDiv: true }
  static propTypes: { hasDiv: Requireable<boolean>; text: Requireable<string>; dataInput: Requireable<string> };

  render(): JSX.Element {
    let { dataInput, className, text, hasDiv, onChange, disabled } = this.props;
    return (
      <div className={`short-answer ${className}`}>
        <div className="type-a-question">{text}</div>
        <input className="frame" type="text" placeholder={i18n.t("common:form.inputPlaceholder")}
          value={dataInput}
          onChange={onChange}
          disabled={disabled}
          required
        />
        {hasDiv && <div className="text-wrapper-2">Type an error message</div>}
      </div>
    );
  }
}

ShortAnswer.propTypes = {
  text: PropTypes.string,
  hasDiv: PropTypes.bool,
  dataInput: PropTypes.string,
};
